import React from "react";

// Unique Argengeo mark: stacked geological layers with a rising lithium arrow.
export default function Logo({ className = "", withText = true }) {
  return (
    <span className={`argengeo-logo ${className}`} aria-label="Argengeo">
      <svg
        className="argengeo-logo__mark"
        viewBox="0 0 40 40"
        role="img"
        aria-hidden="true"
      >
        <defs>
          <linearGradient id="argengeo-grad" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stopColor="#0a2540" />
            <stop offset="100%" stopColor="#123870" />
          </linearGradient>
        </defs>
        <rect x="1" y="1" width="38" height="38" rx="9" fill="url(#argengeo-grad)" />
        <path
          d="M6 28 C 12 24, 16 26, 20 24 S 30 22, 34 24"
          fill="none"
          stroke="#e8ecf3"
          strokeOpacity="0.55"
          strokeWidth="1.5"
        />
        <path
          d="M6 32 C 12 29, 16 31, 20 29 S 30 27, 34 29"
          fill="none"
          stroke="#e8ecf3"
          strokeOpacity="0.35"
          strokeWidth="1.5"
        />
        <path
          d="M11 24 L 20 12 L 29 24"
          fill="none"
          stroke="#f3f5f9"
          strokeWidth="2.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <circle cx="20" cy="12" r="2.6" fill="#c1573b" />
      </svg>
      {withText && (
        <span className="argengeo-logo__wordmark">
          <span className="argengeo-logo__word">Argengeo</span>
          <span className="argengeo-logo__dot" aria-hidden="true" />
        </span>
      )}
    </span>
  );
}
